module.exports = __webpack_public_path__ + "img/78.b1cbd501.jpg";